import { GridColDef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useHostPlayerReservations } from "services/api/SWRService";
import { IHostReservation } from "services/models/Host/HostReservation";
import { dateCol, tierCol } from "utils/datagrid-utils";
import { PlayerNameCell } from "./PlayerNameCell";
import { SWRDataGrid } from "./SWRDataGrid";
import { GridPaginationProps } from "./helpers";
import Routes from "constants/routes";
import { useNavigate } from "react-router-dom";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from ".";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";

export type ReservationStatus = "active" | "upcoming";

type Prop = {
  status: ReservationStatus;
} & GridPaginationProps;

export const ReservationTable = (props: Prop): JSX.Element => {
  const { status, ...pageProps } = props;
  const columns: GridColDef<IHostReservation>[] = [
    {
      field: "currentTier",
      headerName: "Tier",
      ...tierCol,
    },
    {
      field: "fullName",
      headerName: "Player",
      flex: 1,
      minWidth: PLAYER_NAME_MIN_WIDTH,
      renderCell: ({ row }) => <PlayerNameCell {...row} clubNumber={undefined} />,
    },
    { field: "hostName", headerName: "Host", minWidth: 140 },
    {
      field: "checkIn",
      headerName: "Check-in",
      ...dateCol,
      minWidth: 130,
      valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
    },
    {
      field: "checkOut",
      headerName: status === "upcoming" ? "Check Out" : "Scheduled Checkout",
      ...dateCol,
      minWidth: 150,
      valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
    },
  ];
  const navigate = useNavigate();
  const response = useHostPlayerReservations(status);
  const isMobile = useMobile();

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
          },
        },
        sorting: {
          sortModel: [{ field: status == "active" ? "checkOut" : "checkIn", sort: "asc" }],
        },
      }}
      name={`${status}-reservations`}
      response={response}
      {...pageProps}
      columns={columns}
      onRowClick={({ row }) => {
        navigate(Routes.stayFor(row.clubNumber, row.confirmationNumber));
      }}
      slotProps={{
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      noRowsMessage="No Reservations Found"
      clickableRow
    />
  );
};
